import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
const SectionConciergeContact = ({
  header, subheader, subheaderClasses,
  body,
  items,
  containerClasses = '',
  backgroundColor = '#F3F5F6'
}) => {
  return (
    <section
      className={`w-full py-10 lg:py-20 px-4 lg:px-24 xl:px-44 2xl:px-60 ${containerClasses}`}
      style={{ backgroundColor }}
    >
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
        {/* Left Side - Heading and Body */}
        <div className="flex-1 lg:max-w-[650px] px-2">
          <h2 className="text-[#1C2938] text-[32px] lg:text-[40px] font-bold leading-tight mb-6">
            {parse(header || '')}
          </h2>
          <div className="text-[#707070] text-base leading-relaxed">
            {parse(body || '')}
          </div>
        </div>

        {/* Right Side - Contact Card */}
        <div className="bg-white rounded-2xl shadow-sm p-6 lg:p-8 lg:min-w-[486px]">
          <h3 className={subheaderClasses || 'text-[#1C2938] text-xl lg:text-2xl font-bold mb-6'}>
            {parse(subheader || '')}
          </h3>
          
          <div className="space-y-4">
            {items?.map((item, index) => (
              <div key={index} className="flex items-start gap-4">
                {item.image?.url && (
                  <span className="flex-shrink-0">
                    <img src={item.image.url} alt="" className="w-8 h-8" />
                  </span>
                )}
                <span className="text-[#1C2938] text-base">{parse(item.body || '')}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

SectionConciergeContact.propTypes = {
  header: PropTypes.string,
  headerClasses: PropTypes.string,
  subheader: PropTypes.string,
  subheaderClasses: PropTypes.string,
  body: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    header: PropTypes.string.isRequired,
    headerClasses: PropTypes.string,
    subheader: PropTypes.string,
    subheaderClasses: PropTypes.string,
    image: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
    body: PropTypes.string.isRequired
  })).isRequired,
  containerClasses: PropTypes.string,
  backgroundColor: PropTypes.string,
};

export default SectionConciergeContact;